import React, { useRef } from "react";

/**
 * Hero centerpiece: time-lapse of a soil cross-section (rhizotron)
 * where a tomato seed germinates, roots colonise the soil strata,
 * and the plant sets and ripens a single fruit.
 *
 * Compressed to ~270KB MP4 at 720p.
 */
export default function HeroPlant({ className = "" }) {
  const videoRef = useRef(null);

  // Restart video when it ends, with a tiny pause for a more cinematic loop
  const handleEnded = () => {
    const v = videoRef.current;
    if (!v) return;
    setTimeout(() => {
      v.currentTime = 0;
      v.play().catch(() => {});
    }, 250);
  };

  return (
    <div
      className={`relative flex flex-col items-center w-full ${className}`}
      data-testid="hero-plant"
    >
      {/* Soft halo behind the composition */}
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 40%, rgba(158,173,155,0.35), rgba(247,247,244,0) 65%)",
        }}
      />

      {/* PLANT — Soil cross-section timelapse */}
      <div className="relative w-full max-w-[820px] aspect-[4/5] overflow-hidden rounded-3xl bg-white shadow-[0_40px_80px_-20px_rgba(19,51,34,0.3)]">
        <video
          ref={videoRef}
          src="/video/raiz-tomate.mp4"
          poster="/video/raiz-tomate-poster.jpg"
          autoPlay
          muted
          playsInline
          preload="auto"
          onEnded={handleEnded}
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="hero-plant-video"
        >
          <source src="/video/raiz-tomate.mp4" type="video/mp4" />
        </video>

        {/* Subtle vignette to blend with hero bg */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(247,247,244,0) 60%, rgba(247,247,244,0.45) 100%)",
          }}
        />

        {/* Bottom caption inside the frame */}
        <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-[10px] font-mono-eu tracking-[0.25em] uppercase text-[#f7f7f4] drop-shadow-[0_2px_6px_rgba(0,0,0,0.5)]">
          <span className="flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-green-400 animate-pulse"></span>
            Raíz · Ciclo completo
          </span>
          <span>EUZERONE · LAB</span>
        </div>
      </div>
    </div>
  );
}
